/*!
FullCalendar Resource Day Grid Plugin v6.1.15
Docs & License: https://fullcalendar.io/docs/resource-daygrid-view
(c) 2024 Adam Shaw
*/ FullCalendar.ResourceDayGrid = function(e, t, r, a, s, l, o, i, n) {
    "use strict";
    function d(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    var u = d(r), c = d(a), h = d(s);
    class y extends n.VResourceJoiner {
        transformSeg(e, t, r) {
            return t.computeColRanges(e.firstCol, e.lastCol, r).map((t)=>Object.assign(Object.assign(Object.assign({}, e), t), {
                    isStart: e.isStart && t.isStart,
                    isEnd: e.isEnd && t.isEnd
                }));
        }
    }
    class R extends l.DateComponent {
        constructor(){
            super(...arguments), this.splitter = new n.VResourceSplitter, this.slicers = {}, this.joiner = new y, this.tableRef = o.createRef(), this.isHitComboAllowed = (e, t)=>1 === this.props.resourceDayTableModel.dayTableModel.colCnt || e.dateSpan.resourceId === t.dateSpan.resourceId;
        }
        render() {
            let { props: e, context: t } = this, { resourceDayTableModel: r, nextDayThreshold: a, dateProfile: s } = e, n = this.splitter.splitProps(e);
            this.slicers = l.mapHash(n, (e, t)=>this.slicers[t] || new i.DayTableSlicer);
            let d = l.mapHash(this.slicers, (e, l)=>e.sliceProps(n[l], s, a, t, r.dayTableModel));
            return o.createElement(i.Table, Object.assign({
                forPrint: e.forPrint,
                ref: this.tableRef
            }, this.joiner.joinProps(d, r), {
                cells: r.cells,
                dateProfile: s,
                colGroupNode: e.colGroupNode,
                tableMinWidth: e.tableMinWidth,
                renderRowIntro: e.renderRowIntro,
                dayMaxEvents: e.dayMaxEvents,
                dayMaxEventRows: e.dayMaxEventRows,
                showWeekNumbers: e.showWeekNumbers,
                expandRows: e.expandRows,
                headerAlignElRef: e.headerAlignElRef,
                clientWidth: e.clientWidth,
                clientHeight: e.clientHeight,
                isHitComboAllowed: this.isHitComboAllowed
            }));
        }
    }
    class b extends i.TableView {
        constructor(){
            super(...arguments), this.flattenResources = l.memoize(n.flattenResources), this.buildResourceDayTableModel = l.memoize(f), this.headerRef = o.createRef(), this.tableRef = o.createRef();
        }
        render() {
            let { props: e, context: t } = this, { options: r } = t, a = r.resourceOrder || n.DEFAULT_RESOURCE_ORDER, s = this.flattenResources(e.resourceStore, a), l = this.buildResourceDayTableModel(e.dateProfile, t.dateProfileGenerator, s, r.datesAboveResources, t), i = r.dayHeaders && o.createElement(n.ResourceDayHeader, {
                ref: this.headerRef,
                resources: s,
                dateProfile: e.dateProfile,
                dates: l.dayTableModel.headerDates,
                datesRepDistinctDays: !0
            }), d = (t)=>o.createElement(R, {
                    ref: this.tableRef,
                    dateProfile: e.dateProfile,
                    resourceDayTableModel: l,
                    businessHours: e.businessHours,
                    eventStore: e.eventStore,
                    eventUiBases: e.eventUiBases,
                    dateSelection: e.dateSelection,
                    eventSelection: e.eventSelection,
                    eventDrag: e.eventDrag,
                    eventResize: e.eventResize,
                    nextDayThreshold: r.nextDayThreshold,
                    tableMinWidth: t.tableMinWidth,
                    colGroupNode: t.tableColGroupNode,
                    dayMaxEvents: r.dayMaxEvents,
                    dayMaxEventRows: r.dayMaxEventRows,
                    showWeekNumbers: r.weekNumbers,
                    expandRows: !e.isHeightAuto,
                    headerAlignElRef: this.headerElRef,
                    clientWidth: t.clientWidth,
                    clientHeight: t.clientHeight,
                    forPrint: e.forPrint
                });
            return r.dayMinWidth ? this.renderHScrollLayout(i, d, l.colCnt, r.dayMinWidth) : this.renderSimpleLayout(i, d);
        }
    }
    function f(e, t, r, a, s) {
        let l = i.buildDayTableModel(e, t);
        return a ? new n.DayResourceTableModel(l, r, s) : new n.ResourceDayTableModel(l, r, s);
    }
    var p = t.createPlugin({
        name: "@fullcalendar/resource-daygrid",
        premiumReleaseDate: "2024-07-12",
        deps: [
            u.default,
            c.default,
            h.default
        ],
        initialView: "resourceDayGridDay",
        views: {
            resourceDayGrid: {
                type: "dayGrid",
                component: b,
                needsResourceData: !0
            },
            resourceDayGridDay: {
                type: "resourceDayGrid",
                duration: {
                    days: 1
                }
            },
            resourceDayGridWeek: {
                type: "resourceDayGrid",
                duration: {
                    weeks: 1
                }
            },
            resourceDayGridMonth: {
                type: "resourceDayGrid",
                duration: {
                    months: 1
                },
                fixedWeekCount: !0
            }
        }
    }), D = {
        __proto__: null,
        ResourceDayTableView: b,
        ResourceDayTable: R
    };
    return t.globalPlugins.push(p), e.Internal = D, e.default = p, Object.defineProperty(e, "__esModule", {
        value: !0
    }), e;
}({}, FullCalendar, FullCalendar.PremiumCommon, FullCalendar.Resource, FullCalendar.DayGrid, FullCalendar.Internal, FullCalendar.Preact, FullCalendar.DayGrid.Internal, FullCalendar.Resource.Internal);

//# sourceMappingURL=index.6eda0fa7.js.map
